import styled from 'styled-components'

const Wrapper = styled.section`
    .header{
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  h5{
    text-transform: none;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .header .btn{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 0.5rem;
    box-shadow: var(--shadow-2);
    text-transform: none;
  }

  .form {
    width: 100%;
    max-width: 100%;
  }

  .form-center {
    display: grid;
    column-gap: 2rem;
    row-gap: 0.5rem;
    padding-bottom: 20px;
    justify-content: center;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
    @media (min-width: 992px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  .diagramsContainer{
    display: grid;
    grid-template-columns: auto;
    grid-row-gap: 30px;
    @media (min-width: 576px) {
    }
    @media (min-width: 768px) {
    }
    @media (min-width: 992px) {
    }
    @media (min-width: 1120px) {
      grid-template-columns: auto auto;
    }
  }

  .diagramAndHeading{
    text-align: center;
  }

  .diagram{
    height: 300px;
    width: 100%;
    @media (min-width: 576px) {
    }
    @media (min-width: 768px) {
    }
    @media (min-width: 992px) {
    }
    @media (min-width: 1120px) {
    }
  }
`

export default Wrapper